import { withInstall } from '@lit-element/utils'

import Divider from './src/divider.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export const LtDivider: SFCWithInstall<typeof Divider> = withInstall(Divider)
export default LtDivider

export * from './src/divider'
